import { Injectable } from '@angular/core';
import { Userpilot } from 'userpilot';

@Injectable()
export abstract class UserpilotReloader {

  protected constructor() {
    Userpilot.reload();
  }
}
